import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Tenabeltemplate from "../../component/course/tenable";

export default class Tenabelinchennai extends Component {
 
  render() {
  
    const title = "Tenable"
    const url= "tenable"
     const url1 ="-training-in-chennai"
    const location = "chennai" 
    const location1="Training in Chennai"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Accelerate your career growth with Tenable training at Learnsoft.org in ${location}.Whether you're a beginner or an experienced professional, our training program covers everything you need to know about Tenable. Join us now and take the first step towards a successful career as a Tenable expert`}
           url={`course/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Tenabeltemplate url1={url1} url={url} title={title} relatedlocation={"course"} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
